(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  class BimmerfitSearchParameters extends HTMLElement {
    #section;

    connectedCallback() {
      this.#section = this.closest('.shopify-section');
      this.#section?.addEventListener('formdata', this.#preserveFormParameters, true);
      window.addEventListener('click', this.#preserveRemovalParameters, true);
      window.addEventListener('keydown', this.#preserveRemovalParameters, true);
    }

    disconnectedCallback() {
      this.#section?.removeEventListener('formdata', this.#preserveFormParameters, true);
      window.removeEventListener('click', this.#preserveRemovalParameters, true);
      window.removeEventListener('keydown', this.#preserveRemovalParameters, true);
      this.#section = undefined;
    }

    #preserveFormParameters = (event) => {
      if (!(event.target instanceof HTMLFormElement) || event.target.getAttribute('ref') !== 'facetsForm') return;

      const parameters = new URL(window.location.href).searchParams;
      for (const name of ['type', 'options[prefix]']) {
        if (parameters.has(name)) event.formData.set(name, parameters.get(name));
      }
    };

    #preserveRemovalParameters = (event) => {
      if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
      if (!(event.target instanceof Element)) return;

      const remove = event.target.closest('facet-remove-component[data-url]');
      if (!remove || remove.closest('.shopify-section') !== this.#section) return;

      const current = new URL(window.location.href);
      const target = new URL(remove.dataset.url, current);
      if (target.origin !== current.origin || target.pathname !== current.pathname) return;

      for (const name of ['type', 'options[prefix]']) {
        if (current.searchParams.has(name)) target.searchParams.set(name, current.searchParams.get(name));
      }

      remove.dataset.url = target.pathname + target.search + target.hash;
    };
  }

  if (!customElements.get('bf-search-parameters')) {
    customElements.define('bf-search-parameters', BimmerfitSearchParameters);
  }

  } catch(e) { console.error(e); }
})();
})();
